import React from 'react';
import ScrapingShell from '../../../components/ScrapingShell';

/** Admin V2 Referrals — Phase 2 shell. Feature : pages.referrals.admin. */
const AdminV2Referrals = () => (
  <ScrapingShell
    titleKey="referralsV2.title" titleFallback="Referrals"
    bodyKey="referralsV2.body"
    bodyFallback="The referral program (invitations, conversions, payouts) depends on data not yet ingested in Phase 1. Enabled per tenant when the referral source is wired."
  />
);

export default AdminV2Referrals;
